/**
 * Utility per la formattazione di valori economici
 * Formato standard: 1.234,50 (punto per migliaia, virgola per decimali)
 */

/**
 * Formatta un numero come importo economico
 * @param value - Numero da formattare
 * @param options - Opzioni di formattazione
 * @returns Stringa formattata come "1.234,50"
 */
export const formatCurrency = (
  value: number | string | undefined | null,
  options?: {
    minimumFractionDigits?: number
    maximumFractionDigits?: number
    prefix?: string
    suffix?: string
  }
): string => {
  if (value === undefined || value === null) return '0.00'

  const numValue = typeof value === 'string' ? parseFloat(value) : value
  if (isNaN(numValue)) return '0.00'

  const {
    minimumFractionDigits = 2,
    maximumFractionDigits = 2,
    prefix = '',
    suffix = '',
  } = options || {}

  // Usa Intl.NumberFormat per formattazione affidabile della locale
  const formatter = new Intl.NumberFormat('it-IT', {
    minimumFractionDigits,
    maximumFractionDigits,
    useGrouping: true
  })
  
  const formatted = formatter.format(numValue)

  return `${prefix}${formatted}${suffix}`
}

/**
 * Shorthand per formattare con simbolo €
 */
export const formatEuro = (value: number | string | undefined | null): string => {
  return formatCurrency(value, { prefix: '€ ' })
}

/**
 * Formatta per visualizzazione in tabelle
 */
export const formatTableAmount = (value: number | string | undefined | null): string => {
  return formatCurrency(value, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
}
